<template>
	<div>
		<!-- =========== End of Loader ============ -->

		<main class="main hidden">
			<!-- =========== Start of Navigation (main menu) ============ -->
			<header class="navbar navbar-expand-lg navbar-dark">
				<div class="container position-relative">
					<router-link to="/" class="navbar-brand">
						<img
							class="navbar-brand__regular"
							src="/assets/logo.png"
							alt="brand-logo"
							width="80px"
							height="80px"
						/>
					</router-link>
					<!--  End of brand logo -->
				</div>
				<!-- end of container -->
			</header>
			<!-- =========== End of Navigation (main menu)  ============ -->

			<!-- =========== Start of Body ============ -->
			<section
				class="space bg-color--dark--1 h-min-100vh d-flex align-items-center"
			>
				<div class="svg-shape--top w-100 opacity--05">
					<img
						src="/assets/img/wave-8.svg"
						alt="wave"
						class="svg fill--white"
					/>
				</div>
				<!-- end of whole area svg bg -->
				<div class="svg-shape--top opacity--10">
					<img src="assets/img/wave-9.svg" alt="wave" class="svg fill--white" />
				</div>
				<!-- end of top right mini svg shape -->

				<div class="container">
					<div class="row">
						<div class="col-12 mx-auto color--white text-center mb-2 mb-lg-2">
							<h1 class="h2-font mb-1 text-white">{{ $t("login.code") }}</h1>
						</div>
						<div class="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-6 mx-auto">
							<div
								class="form--v5 bg-color--light--1 px-3 py-4 px-md-5 py-md-6 rounded--10"
							>
								<form class="form">
									<div
										class="alert alert-danger"
										role="alert"
										id="alert"
										v-show="alert"
									>
										{{ err }}
									</div>
									<div class="form-group">
										<!-- <label class="form__label text-uppercase font-size--15 font-w--500">{{$t("login.code")}}</label> -->
										<label
											for="otpCode"
											class="form__label text-uppercase font-size--15 font-w--400"
											>کد ارسالی</label
										>
										<input
											id="otpCode"
											v-model.trim="$v.otp_code.$model"
											type="number"
											@wheel="$event.target.blur()"
											class="form-control"
											:class="{ 'is-invalid': $v.otp_code.$error }"
											placeholder="کد ارسالی را وارد کنید"
											@blur="$v.otp_code.$touch()"
										/>
										<div class="invalid-feedback" v-if="!$v.otp_code.sameAs">
											کد ارسالی را وارد کنید
										</div>
										<!-- <div
											class="text-color--400 font-size--10 mt-2 mt-sm-0 text-center"
										>
											<a
												role="button"
												type="button"
												:disabled="counting"
												@click="startCountdown"
											>
												<countdown
													v-if="counting"
													:time="120000"
													@end="handleCountdownEnd"
													class="text-color--400 font-size--10 mt-2 mt-sm-0 text-center"
												>
													<template slot-scope="props">
														ارسال دوباره کد بعد از
														{{ props.totalSeconds }} ثانیه
													</template>
												</countdown>
												<span
													class="text-color--400 font-size--10 mt-2 mt-sm-0 text-center"
													v-else
													><a class="btn" role="button" @click="resentOtp">
														ارسال دوباره کد</a
													></span
												>
											</a>
										</div> -->
									</div>
									<div class="form-group">
										<label
											for="newPass"
											class="form__label text-uppercase font-size--15 font-w--400"
											>رمز عبور جدید</label
										>
										<input
											id="newPass"
											v-model.trim="$v.new_pass.$model"
											type="password"
											@wheel="$event.target.blur()"
											class="form-control"
											:class="{ 'is-invalid': $v.new_pass.$error }"
											@blur="$v.new_pass.$touch()"
											placeholder="رمز عبور جدید را وارد کنید"
										/>
										<div class="invalid-feedback" v-if="!$v.new_pass.required">
											لطفا کلمه عبور را وارد کنید
										</div>

										<div class="invalid-feedback" v-if="!$v.new_pass.minLength">
											کلمه عبور باید حداقل شامل
											{{ $v.new_pass.$params.minLength.min }} کاراکتر باشد
										</div>
									</div>
									<div class="form-group">
										<label
											for="rePass"
											class="form__label text-uppercase font-size--15 font-w--400"
											>تکرار رمز عبور جدید</label
										>
										<input
											id="rePass"
											v-model.trim="$v.re_pass.$model"
											:class="{ 'is-invalid': $v.re_pass.$error }"
											@blur="$v.re_pass.$touch()"
											type="password"
											@wheel="$event.target.blur()"
											class="form-control"
											placeholder="تکرار رمز عبور جدید را وارد کنید"
											required
										/>
										<div class="invalid-feedback" v-if="!$v.re_pass.sameAs">
											تکرار رمز عبور با رمز عبور مطابق نیست
										</div>
									</div>

									<div
										class="d-flex justify-content-between flex-column-reverse flex-sm-row align-items-sm-center"
									>
										<router-link
											to="forgot-pass"
											class="text-color--400 font-size--15 mt-2 mt-sm-0"
											>{{ $t("login.incorrectPhoneNumber") }}
										</router-link>
										<button
											class="btn btn-bg--primary btn-size--md btn-hover--3d"
											type="submit"
											@click.prevent="checkForgotPassOtp"
										>
											<span class="btn__text">ثبت</span>
										</button>
									</div>
								</form>
								<!-- end of form -->
							</div>
							<!-- end of from area -->
						</div>
						<!-- end of col -->
					</div>
					<!-- end of row -->
				</div>
				<!-- end of container -->
			</section>
			<!-- =========== End of Body ============ -->
		</main>
	</div>
</template>

<script>
	// import Countdown from "@chenfengyuan/vue-countdown";
	import { required, sameAs, minLength } from "vuelidate/lib/validators";
	export default {
		data() {
			return {
				alert: false,
				counting: true,
				otp_code: "",
				new_pass: "",
				re_pass: "",
				err: "",
			};
		},
		// beforeCreate: function () {
		// 	if (localStorage.getItem("mobile_number") == null) {
		// 		this.$router.push("/forgot-pass");
		// 	}
		// },
		methods: {
			checkForgotPassOtp() {
				const checkData = {
					token: this.otp_code,
					mobile_number: localStorage.getItem("mobile_number"),
					new_password: this.new_pass,
				};
				this.$v.$touch();
				if (this.$v.$invalid) {
					this.submitStatus = "ERROR";
				} else {
					this.$store
						.dispatch("checkForgotPassOtp", checkData)
						.then(() => {
							this.alert = false;
							this.$router.push("/new-pass-success");
						})
						.catch((err) => {
							this.alert = true;
							this.err = err.body.error;
							console.log(err);
						});
				}
			},
			// resentOtp() {
			// 	this.$store
			// 		.dispatch("resentOtp")
			// 		.then((resp) => {
			// 			console.log(resp);
			// 		})
			// 		.catch((err) => {
			// 			console.log(err);
			// 		});
			// },
			startCountdown() {
				this.counting = true;
			},
			handleCountdownEnd() {
				this.counting = false;
			},
		},
		components: {
			// VueCountdown.name,
			// Countdown
		},
		validations: {
			otp_code: {
				required,
			},
			new_pass: {
				minLength: minLength(6),
				required,
			},
			re_pass: {
				required,
				sameAs: sameAs("new_pass"),
			},
		},
	};
</script>
<style scoped>
	a {
		/* font-size: 0.9375rem; */
		font-size: 0.75rem;
		font-weight: 300;
	}
</style>
